var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "subscription-list" },
    [
      _vm.loading
        ? _c("VLoading")
        : !_vm.loading && _vm.cards.length === 0
        ? _c("VEmpty")
        : [
            _c(
              "div",
              { staticClass: "subscription-content" },
              _vm._l(_vm.cards, function (card) {
                return _c(
                  "a",
                  {
                    key: card.id,
                    staticClass: "subscription-card",
                    attrs: { href: card.playUrl, target: "_blank" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "subscriptions-cover-container" },
                      [
                        _c("DpiImage", {
                          staticClass: "cover",
                          attrs: { src: card.coverUrl, size: 64 },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-info" }, [
                      _c(
                        "h1",
                        { staticClass: "title", attrs: { title: card.title } },
                        [_vm._v(_vm._s(card.title))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "progress-row" }, [
                        card.status
                          ? _c(
                              "div",
                              {
                                staticClass: "status",
                                class: "status-" + card.status,
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(card.statusText) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        card.progress
                          ? _c(
                              "div",
                              {
                                staticClass: "progress",
                                attrs: {
                                  title: card.progress + " | " + card.latest,
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(card.progress) +
                                    " | " +
                                    _vm._s(card.latest) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "progress",
                                attrs: { title: card.latest },
                              },
                              [_vm._v(_vm._s(card.latest))]
                            ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "info",
                            attrs: {
                              href: card.mediaUrl,
                              target: "_blank",
                              title: "详细信息",
                            },
                          },
                          [
                            _c("VIcon", {
                              attrs: {
                                icon: "mdi-information-outline",
                                size: 16,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.hasMorePage
              ? _c("ScrollTrigger", {
                  on: {
                    trigger: function ($event) {
                      return _vm.nextPage()
                    },
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }